
export function Round(value: number, decimals: number): number;
export function Round(value: number|null, decimals: number): number|null;
export function Round(value: number|undefined, decimals: number): number|undefined;
export function Round(value: number|undefined|null, decimals: number): number|null|undefined {
    if(value === null)
        return null

    if(value === undefined)
        return undefined

    return Math.round(value * (10 ** decimals)) / (10 ** decimals)
}

export function RoundForHumanReadability(num: number): number {
    // Convert the number to a string
    const strNum = num.toFixed(14) // Remove excess precision

    // If there's no decimal point, return the number as it is
    if (!strNum.includes(".")) return num

    // Split the string number into its integer and fractional parts
    const [intPart, fracPart] = strNum.split(".")

    // If the fractional part is very close to 1 when rounded, round the entire number up
    if (parseFloat("0." + fracPart) > 0.9999999999) {
        return Math.round(num)
    }

    // Remove trailing zeros
    const trimmedFrac = fracPart.replace(/0+$/, "")

    // If after removing trailing zeros, the fractional part becomes empty, return the integer part as a number
    if (!trimmedFrac) return parseInt(intPart)

    // Combine the integer and trimmed fractional parts and return as a number
    return parseFloat(intPart + "." + trimmedFrac)
}
